import axios from 'axios'
import FileDownload from'js-file-download'

const api = {

  // election period

  async getElectionPeriod () {
    return axios.get('/api/pk/electionperiods/active').then(response => response.data)
  },

  // practice period

  async getPracticePeriods () {
    return axios.get('/api/pk/practiceperiods').then(response => response.data)
  },

  async getPracticePeriod (id) {
    return axios.get('/api/pk/practiceperiods/' + id).then(response => response.data)
  },

  async createPracticePeriod (practicePeriod) {
    return axios.post('/api/pk/practiceperiods', practicePeriod)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async updatePracticePeriod (practicePeriod) {
    return axios.put('/api/pk/practiceperiods/' + practicePeriod.practicePeriodId, practicePeriod)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async deletePracticePeriod (id) {
    return axios.delete('/api/pk/practiceperiods/' + id).then(response => response.data)
  },

  // practice period and students

  async getPracticePeriodStudents (id) {
    return axios.get('/api/pk/practiceperiods/' + id + '/students').then(response => response.data)
  },

  async getPracticePeriodStudent (id, studentId) {
    return axios.get('/api/pk/practiceperiods/' + id + '/students/' + studentId).then(response => response.data)
  },

  async createPracticePeriodStudent (student) {
    return axios.post('/api/pk/practiceperiods/' + student.practicePeriodId + '/students', student)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async updatePracticePeriodStudent (student) {
    return axios.put('/api/pk/practiceperiods/' + student.practicePeriodId + '/students/' + student.studentId, student)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async deletePracticePeriodStudent(id, studentId) {
    return axios.delete('/api/pk/practiceperiods/' + id + '/students/' + studentId).then(response => response.data)
  },

  // practice slots

  async getPracticeSlots () {
    return axios.get('/api/pk/practiceslots').then(response => response.data)
  },

  async getPracticeSlotsSpecial () {
    return axios.get('/api/pk/practiceslots/special').then(response => response.data)
  },

  async getPracticeSlotsPharmacies (study) {
    return axios.get('/api/pk/practiceslots/pharmacies?study=' + study).then(response => response.data)
  },

  async getPharmacySlots (id, study) {
    return axios.get(`/api/pk/practiceslots/pharmacies/${id}?study=${study}`).then(response => response.data)
  },

  async getWishes (id) {
    return axios.get('/api/pk/students/wishes' + (id ? ('/' + id) : '')).then(response => response.data)
  },

  async assignPracticeSlotSpecial (practiceSlotId, studentId) {
    return axios.put(`/api/pk/practiceslots/${practiceSlotId}/assignspecial/${studentId}`).then(response => response.data)
  },

  async unassignPracticeSlotSpecial (practiceSlotId) {
    return axios.put(`/api/pk/practiceslots/${practiceSlotId}/unassignspecial`).then(response => response.data)
  },

  export () {
    axios.get('/api/pk/practiceslots/export', { responseType: 'blob' }).then((response) => {
      FileDownload(response.data, 'praksisplasser.xlsx')
    })
  },

  exportAvailable () {
    axios.get('/api/pk/practiceslots/available', { responseType: 'blob' }).then((response) => {
      FileDownload(response.data, 'ledige_praksisplasser.xlsx')
    })
  },

  async getAvailablePracticeSlots (study, studentId) {
    return await axios.get('/api/pk/practiceslots/available/' + study + '/' + studentId).then(response => response.data)
  },

  async assignPracticeSlot (studentId, practiceSlotId) {
    return await axios.post('/api/pk/practiceSlots/assign', { studentId, practiceSlotId }).then(response => response.data)
  },


  // students

  async getUnslottedStudents () {
    return axios.get('/api/pk/students/unslotted').then(response => response.data)
  },

  async deleteStudent (studentId) {
    return await axios.delete('/api/pk/students/' + studentId)
    .then(response => response.data)
    .catch(error => error.response.data)
  },


  // pharmacies

  async getPharmacy (id) {
    return axios.get('/api/pk/pharmacies/' + id).then(response => response.data)
  },



}

export default api